import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from "./eng.json";
import translationAR from './ar.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      ar: { translation: translationAR }
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;
